"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import Link from "next/link";
import { useEffect, useRef, useState } from "react";
import { useLocale, useTranslations } from "next-intl";
import { POSTS as ALL_POSTS } from "./blog/posts-data";

/** Newest three, linking to this site's own article pages. */
const POSTS = [...ALL_POSTS].sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()).slice(0, 3);
export default function BlogSection(t0) {
  const $ = _c(24);
  const {
    isArabic
  } = t0;
  const t = useTranslations("Home");
  const locale = useLocale();
  const gridRef = useRef(null);
  const [visible, setVisible] = useState(false);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      const el = gridRef.current;
      if (!el) {
        return;
      }
      const observer = new IntersectionObserver(t3 => {
        const [entry] = t3;
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      }, {
        threshold: 0.15
      });
      observer.observe(el);
      return () => observer.disconnect();
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  const t3 = isArabic ? "rtl" : "ltr";
  let t4;
  if ($[2] !== t) {
    t4 = t("blogTitle");
    $[2] = t;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t4) {
    t5 = <h2 className="m-0 w-full bg-[linear-gradient(89.18deg,#0CA5F0_15.53%,#FFFFFF_220.84%)] bg-clip-text text-center text-[26px] font-black leading-[1.35] text-transparent min-[500px]:text-[30px] lg:text-[36px]">{t4}</h2>;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== isArabic || $[7] !== locale || $[8] !== visible) {
    t6 = POSTS.map((post, idx) => <Link key={post.id} href={`/${locale}/blog/${post.slug}`} aria-label={post.title[locale === "ar" ? "ar" : "en"]} className="group relative block w-full max-w-91.75 cursor-pointer transition-[transform,opacity] duration-700 ease-out focus:outline-none" style={{
      height: "391.62px",
      transitionDelay: `${idx * 120}ms`,
      transform: visible ? "translate(0, 0)" : "translate(-60px, 60px)",
      opacity: visible ? 1 : 0
    }}><div className="absolute inset-x-0 top-0 overflow-hidden rounded-t-3xl rounded-b-sm bg-white" style={{
        bottom: "28.76%"
      }}><Image src={post.cover} alt={post.title[locale === "ar" ? "ar" : "en"]} fill={true} sizes="(max-width: 640px) 92vw, (max-width: 1024px) 45vw, 367px" className="object-cover object-center" draggable={false} /></div><div className={`absolute bottom-0 flex flex-col justify-between gap-2.25 px-6 py-5
                   top-[67.41%] left-[2.45%] right-[2.45%]
                   rounded-t-sm rounded-b-3xl
                   bg-[#13192B]
                   transition-[top,background-color,border-radius] duration-300 ease-out
                    group-hover:top-[59.69%] group-hover:bg-[#086EA8] group-hover:rounded-t-xl
                    group-focus-within:top-[59.69%] group-focus-within:bg-[#086EA8] group-focus-within:rounded-t-xl
                   ${isArabic ? "items-end text-right" : "items-start text-left"}`}><p className={"m-0 text-[16px] font-normal leading-7.5 text-white\n                   transition-[font-size,line-height] duration-300\n                   group-hover:text-[18px] group-hover:font-bold group-hover:leading-8.5\n                   group-focus-within:text-[18px] group-focus-within:font-bold group-focus-within:leading-8.5"}>{post.title[locale === "ar" ? "ar" : "en"]}</p><span aria-hidden="true" className={"flex h-[27.62px] w-[27.62px] shrink-0 items-center justify-center rounded-full border border-white text-white\n                     transition-[border-width,background-color,color] duration-200\n                     group-hover:border-2 group-hover:bg-white group-hover:text-[#13192B]\n                     group-focus-within:border-2"}><svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" className={isArabic ? "" : "rotate-180"}><path d="M7.5 9L4.5 6L7.5 3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /></svg></span></div></Link>);
    $[6] = isArabic;
    $[7] = locale;
    $[8] = visible;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t6) {
    t7 = <div ref={gridRef} className="grid w-full grid-cols-1 justify-items-center gap-8 sm:grid-cols-2 lg:grid-cols-3 lg:gap-8">{t6}</div>;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  const t8 = `/${locale}/blog`;
  let t9;
  if ($[12] !== t) {
    t9 = t("blogViewAll");
    $[12] = t;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== t8 || $[15] !== t9) {
    t10 = <Link href={t8} className="inline-flex min-h-12 items-center justify-center rounded-full border border-sky-500/40 px-7 text-[16px] font-bold text-white transition-colors duration-300 hover:bg-white hover:text-[#13192B] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#0CA5F0]">{t9}</Link>;
    $[14] = t8;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t10 || $[18] !== t5 || $[19] !== t7) {
    t11 = <div className="mx-auto flex w-full max-w-310 flex-col items-center gap-14 lg:gap-21">{t5}{t7}{t10}</div>;
    $[17] = t10;
    $[18] = t5;
    $[19] = t7;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== t11 || $[22] !== t3) {
    t12 = <section id="blog" className="relative px-4 py-14 md:px-6 lg:px-8 lg:py-20" dir={t3}>{t11}</section>;
    $[21] = t11;
    $[22] = t3;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  return t12;
}